/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SaveRejectionRequest { 
    date: string;
    cityId: number;
    storeId?: number;
    clientId?: number;
    productInfoIds?: Array<number>;
    decor?: boolean;
    deliveryTimes?: Array<string>;
    pickupTimes?: Array<string>;
    note?: string;
    promos?: Array<string>;
    addresses?: Array<string>;
    delivery?: boolean;
    pickup?: boolean;
    orderId?: number;
}

